import {loadMessages, locale} from 'devextreme/localization';
import esMessages from 'devextreme/localization/messages/es.json';
import React from 'react';
import ReactDOM from 'react-dom';
import {i18n, init as i18nInit} from 'src/i18n';
import {AuthToken} from './modules/auth/authToken';
import TenantService from './modules/tenant/tenantService';

/**
 * Mitigación ChunkLoadError: cuando HMR intenta cargar un chunk (ej. hot-update.js)
 * y el servidor devuelve HTML en vez de JS (404, fallback SPA), recargar la página
 * para obtener chunks válidos.
 */
(function setupChunkErrorReload() {
  const isChunkError = (msg: string, err?: { name?: string; message?: string }) =>
    err?.name === 'ChunkLoadError' ||
    msg?.includes?.('ChunkLoadError') ||
    msg?.includes?.('Loading chunk') ||
    msg?.includes?.('Loading hot update chunk') ||
    msg?.includes?.('hot-update');

  window.addEventListener('error', (event) => {
    if (isChunkError(event.message || '', event.error)) {
      event.preventDefault();
      event.stopPropagation();
      console.warn('[ChunkLoadError] Recargando página tras fallo de hot-update...');
      window.location.reload();
      return true;
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message || String(event.reason || '');
    const err = event.reason;
    if (isChunkError(msg, err)) {
      event.preventDefault();
      console.warn('[ChunkLoadError] Recargando página tras fallo de carga de chunk...');
      window.location.reload();
      return true;
    }
  });
})();

(async function () {
  loadMessages(esMessages);
  locale(navigator.language);

  AuthToken.applyFromLocationUrlIfExists();
  await i18nInit();
  await TenantService.fetchAndApply();

  const App = require('./App').default;
  document.title = i18n('app.title');

  // Sentry.init({
  //   dsn: 'https://f91cfd0435b6415f8a801f6cefc74310@o1335223.ingest.sentry.io/6602843',
  //   integrations: [new BrowserTracing()],

  //   // Set tracesSampleRate to 1.0 to capture 100%
  //   // of transactions for performance monitoring.
  //   // We recommend adjusting this value in production
  //   tracesSampleRate: 1.0,
  // });

  ReactDOM.render(<App />, document.getElementById('root'));
})();
